import { refreshTokenRequest } from './auth-service';
import AuthData from './auth-data';
import { signOut } from './auth-service';

const UNAUTHORIZED_ERROR = 401;

const withAuth = <T, U extends [...U]>(fn: (token: string, ...args: U) => T | any) => {
  return (...args: U) =>
    AuthData.get().then(data => {
      if (!data) {
        return signOut();
      }

      return fn(data.token, ...args).catch((err: { status: number }) => {
        if (err.status !== UNAUTHORIZED_ERROR) throw err;

        return refreshTokenRequest(data.refresh_token)
          .then(refreshTokenResponse => {
            AuthData.set({
              ...data,
              token: refreshTokenResponse.token,
              refresh_token: refreshTokenResponse.refresh_token,
            });
            return fn(refreshTokenResponse.token, ...args);
          })
          .catch((err: { status: number }) => {
            if (err.status !== UNAUTHORIZED_ERROR) throw err;
            return signOut();
          });
      });
    }) as Promise<T>;
};

export default withAuth;
